import { useLocation } from 'react-router-dom'
const MODE = 'mode'
const EMBEDDED_MODE = 'embedded'

function isEmbeddedMode(searchParams) {
  const params = new URLSearchParams(searchParams)
  return params.get(MODE) === EMBEDDED_MODE
}

function getNavigatedFromKey(searchParams) {
  const params = new URLSearchParams(searchParams)
  return params.get('navigatedFrom')
}

function useFunctionalDiagrams() {
  const location = useLocation()
  return location.pathname.includes('functional-diagrams')
}

function useIsBlockDiagramPreview() {
  const location = useLocation()
  return location.pathname.includes('block-diagram-preview')
}

export function useIsGlobalSearchVinPage() {
  const location = useLocation()
  return location.pathname.includes('global-search/vin/')
}

export function useIsGlobalSearchConfigurationPage() {
  const location = useLocation()
  return location.pathname.includes('global-search/configuration')
}

export function useIsFunctionalDiagramsVINPage() {
  const location = useLocation()
  return location.pathname.includes('functional-diagrams/vin')
}

// The sign-in page is reached without a session, so the header's navigation,
// search and user menu cannot be used there.
export function useIsLoginPage() {
  const location = useLocation()
  return location.pathname === '/login'
}

export {
  isEmbeddedMode,
  getNavigatedFromKey,
  useFunctionalDiagrams,
  useIsBlockDiagramPreview,
  MODE,
  EMBEDDED_MODE,
}
